export { default as MediasCarousel } from './MediasCarousel';
